<router-outlet></router-outlet>
@if(!isProduction){
    <angular-query-devtools/>
}